import React, { useEffect, useRef } from "react";
import styled, { ThemeProvider,keyframes } from "styled-components";
import { DarkTheme } from "./Themes";
import { motion } from "framer-motion";

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";

import { Work } from "../data/WorkData";
import { YinYang } from "./AllSvgs";
import BigTitlte from "../subComponents/BigTitlte";
import ProjectCard from "../subComponents/ProjectCard";
import './WorkPage.css';
import ArrowDown from "./ArrowDown";

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  height: 1000vh;
  // position: relative;
  display: flex;
  align-items: flex-start;
`;

const Main = styled(motion.ul)`
  position: fixed;
  top: 13rem;
  height: 800vh;
  display: flex;
  color: white;
  left: 0;
  margin-left:2rem;
  @media screen and (max-width: 700px) {
    top:9rem;
    top:13.5rem;
  }
  @media screen and (max-width: 400px) {
    top:9rem;
    top:13rem;
    margin-left:-1rem;

  }
  @media screen and (max-width: 320px) {
    top:9rem;
    top:13rem;
    margin-left:-2rem;

  }

`;
const Rotate = styled.span`
  display: block;
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  width: 80px;
  height: 80px;
  z-index: 1;
`;

const float = keyframes`
0% {
  transform: rotate(45deg);
  transform: translateY(0);
}
50% {
  transform: rotate(45deg);
  transform: translateY(-20px); // Move up by 20px
}
100% {
  transform: rotate(45deg);
  transform: translateY(0);
}
`;
const bg = '#2d2d37'; // Dark blue
const primary = '#fd6b21'; // Orange;
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
`;

 

// Framer-motion Configuration
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const WorkPage = () => {
  const ref = useRef(null);
  const yinyang = useRef(null);

  useEffect(() => {
    let element = ref.current;

    const rotate = () => {
      element.style.transform = `translateX(${-window.pageYOffset}px)`;

      return (yinyang.current.style.transform =
        "rotate(" + -window.pageYOffset + "deg)");
    };

    window.addEventListener("scroll", rotate);
    return () => {
      window.removeEventListener("scroll", rotate);
    };
  }, []);
  

  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
      
        <Main ref={ref} variants={container} initial="hidden" animate="show">
          {Work.map((data) => (
            <ProjectCard key={data.id} data={data} />
            
          ))}
          <ProjectCard className="project-card" key={6} data={{
    id:1,
    name:"StakeWise",
    description:"StakeWise (InProgress): A DAPP where your returns with Diverse Yield Farming Options. Connect to Liquidity Pools, AMMs, and DeFi Protocols to Tailor Your Strategy.",
    tags:[],
    img:"https://media.giphy.com/media/xTkcEQACH24SMPxIQg/giphy.gif",
    demo:"",
    github:""
  }}  

  />
        </Main>
        {/* <Rotate ref={yinyang}>
          <YinYang width={80} height={80} fill={DarkTheme.text}  className="yinyang"/>
        </Rotate> */}
        
        <BigTitlte text="WORK" top="10%" right="20%" />
        {/* <DownArrow/>
        <StyledArrow/> */}
        <ArrowDown />
      </Box>
     
    </ThemeProvider>
  );
};

export default WorkPage;